import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { PAYMENT_LIST } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import TableLayout from '../layout/TableLayout';
import { PAYMENT_MODE, PAYMENT_TYPES } from '../../../data/constant';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FormLayout from '../layout/FormLayout';

export default function PaymentList() {

  const [list, setPaymentList] = useState([]);

  const { t } = useTranslation();

  const tableHeaders = ['#', 'date', 'number', 'type', 'account_name', 'mode', 'amount', 'action'];

  const keys = ["payment_date", "number", "type", "full_name", "mode", "amount", "btnEdit"];

  const btnData = {
    btnEdit: {
      name: "View", link: "/root/payment/view"
    }
  }

  const object = [
    { key: 'type', value: PAYMENT_TYPES },
    { key: 'mode', value: PAYMENT_MODE }
  ]

  useEffect(() => {
    getPaymentList();
  }, []);

  const getPaymentList = async (payload = {}) => {
    const res = await httpClient.post(PAYMENT_LIST, payload);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        setPaymentList(result.data);
      }
    }
  }

  const [formData, setFormData] = useState({
    formTitle: 'Search Customer',
    formFields: [
      { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-2" },
      { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-2" },
      { label: 'customer_vendor', id: 'customer', type: 'text', name: 'name', value: '', className: "col-md-3", placeholder: 'Enter name' },
      { label: 'number', id: 'number', type: 'text', name: 'number', value: '', className: "col-md-3", placeholder: 'Enter number' },
    ],
    formErrors: { from_date: '', to_date: '', name: '', number: '' },
  });

  const handleFieldChange = (fieldName, value) => {
    setFormData((prevFormData) => {
      const updatedFormFields = prevFormData.formFields.map((field) =>
        field.name === fieldName ? { ...field, value: value } : field
      );
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  }

  const handleFieldBlur = () => { }

  const handleSubmit = (e) => {
    e.preventDefault();
    let post = {};
    const updatedFormFields = formData.formFields.map((field) => {
      post[field.name] = field.value;
      return field;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
    }));
    getPaymentList(post);
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader title="payment" />
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <FormLayout
                formTitle={formData.formTitle}
                formFields={formData.formFields}
                formErrors={formData.formErrors}
                onFieldChange={handleFieldChange}
                onFieldBlur={handleFieldBlur}
                onSubmit={handleSubmit}
                isModal
                search
              />
              <div className='mb-2'>
                <Link to={"/root/payment/customerPayment"} className='btn btn-primary btn-sm' >{t('customer_payment')}</Link>
                <Link to={"/root/payment/vendorPayment"} className='btn btn-success btn-sm ml-2' >{t('vendor_payment')}</Link>
              </div>
              <TableLayout
                headers={tableHeaders}
                keys={keys}
                tableData={list}
                id="id"
                btnData={btnData}
                numberKey={["amount"]}
                object={object}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
